import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { bookParts } from "../data/book";
export function InsidePreview() {
  return <section id="inside" className="scroll-mt-20 bg-ink py-24 lg:py-32" data-id="element-85" data-mp="2r8d0wynqw5ts">
      <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-86" data-mp="2m99zdo6z4hqk">
        <h2 className="font-display text-4xl text-cream sm:text-5xl" data-id="element-87" data-mp="2mbwgaefr89lg">A preview of what’s inside</h2>

        <div className="mt-14 grid gap-16 lg:grid-cols-2 lg:gap-0 lg:divide-x lg:divide-line" data-id="element-88" data-mp="2hdcv4g8zj1u5">
          {bookParts.map((part, i) => <article key={part.part} className={`flex flex-col ${i === 0 ? "lg:pr-14" : "lg:pl-14"}`} data-id="element-89" data-mp="39zxgn02s4jps" data-mpi={i}>
              <p className="font-serif text-sm tracking-[0.3em] text-gold" data-id="element-90" data-mp="358fh8ggemr6x">
                {part.part.toUpperCase()}
              </p>
              <h3 className="mt-3 font-display text-3xl text-cream sm:text-4xl" data-id="element-91" data-mp="309bb5yos19kt">{part.title}</h3>
              <p className="mt-2 font-serif text-xl italic text-muted" data-id="element-92" data-mp="1km5q8h02ytb">{part.tagline}</p>

              {part.paragraphs.map(p => <p key={p} className="mt-5 text-lg leading-relaxed text-muted" data-id="element-93" data-mp="3sx75iwqvipef">
                  {p}
                </p>)}

              {part.stories.length > 0 && <ul className="mt-6 divide-y divide-line border-y border-line" data-id="element-94" data-mp="3qp4n4kq2seon">
                  {part.stories.map(story => <li key={story.venture} className="grid grid-cols-[1fr_auto_1fr] items-center gap-4 py-3.5" data-id="element-95" data-mp="3c0i52b92d8tq">
                      <span className="font-medium text-cream" data-id="element-96" data-mp="3gxibwodqmflw">{story.venture}</span>
                      <ArrowRightIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-97" data-mp="32ysch23g43ud" />
                      <span className="text-muted" data-id="element-98" data-mp="3715b76jrz1hn">
                        <span className="sr-only" data-id="element-99" data-mp="36yj0iy1l85v7">avoided </span>
                        {story.failureMode}
                      </span>
                    </li>)}
                </ul>}

              <div className="mt-auto pt-8" data-id="element-100" data-mp="2y0h46vssu1e9">
                <p className="border-l-2 border-gold pl-5 font-serif text-xl leading-snug text-cream" data-id="element-101" data-mp="r9r3uxlw9e40">
                  {part.takeaway}
                </p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}